"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IClientRegistration = void 0;
const openapi_1 = require("../../../openapi");
const app_product_1 = require("./app-product");
class IClientRegistration {
    id;
    secret;
    orgKey;
    productAccess;
    permissions;
    created;
    referrerHosts;
    expirationDate;
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'string',
        description: 'Leave empty to allow the system to assign a uuid',
        format: 'uuid',
    })
], IClientRegistration.prototype, "id", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'string',
        description: 'System assigned - will only be returned once in the create response',
        format: 'uuid',
    })
], IClientRegistration.prototype, "secret", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IClientRegistration.prototype, "orgKey", void 0);
__decorate([
    (0, openapi_1.Schema)(() => app_product_1.IProductAccess)
], IClientRegistration.prototype, "productAccess", void 0);
__decorate([
    (0, openapi_1.Schema)(() => app_product_1.IAppPermissions)
], IClientRegistration.prototype, "permissions", void 0);
__decorate([
    (0, openapi_1.Schema)({
        type: 'number',
        description: 'System assigned on create - just pass 0 or anything on create',
    })
], IClientRegistration.prototype, "created", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: { type: 'string' } })
], IClientRegistration.prototype, "referrerHosts", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'number',
        nullable: true,
        description: 'Setting to null will remove the expiration date',
    })
], IClientRegistration.prototype, "expirationDate", void 0);
exports.IClientRegistration = IClientRegistration;
